import { render, staticRenderFns } from "./AmetrasButtonTemplate.vue?vue&type=template&id=7deab1aa&scoped=true&"
import script from "./AmetrasButtonTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasButtonTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasButtonTemplate.vue?vue&type=style&index=0&id=7deab1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deab1aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
